<template>
	<div class="taxonomy-chooser-container">
		<ModalHeader
			:title="getString('x_taxonomy', [category.name])"
			:button-text="getString('save')"
			@click-button="saveClicked" >
		</ModalHeader>
		<div class="taxonomy-chooser">
			<div class="single-taxonomy" v-for="taxonomy in iconsTaxonomy">
				<div class="taxonomy-title">{{ getString(taxonomy.taxonomy) }}</div>
				<div class="taxonomy-icons">
					<div class="taxonomy-icon" v-for="icon in taxonomy.icons" @click="selectTaxonomy(icon)" :class="{selected: currentTaxonomyIcon === icon}">
						<div class="taxonomy-background">
							<img :src="URL_HTML+'/img/categories/'+icon+'.php?c='+primaryColor+'&b=bfd0e4'"  />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useMenuStore, useUserStore} from "@/console-new/stores";
import {categoriesTaxonomy} from "@/shared/helpers/data";
import {isTextColorDark} from "@/shared/helpers/ui";
import API from "@/shared/helpers/API";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let menuStore = useMenuStore();
		let userStore = useUserStore();
		let notificationStore = useNotificationStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, menuStore, userStore};
	},
	name: "TaxonomyChooser",
	components: {ModalHeader},
	data() {
		return {
			URL_HTML,
			currentTaxonomyIcon: null,
		};
	},
	props: {
		categoryTempId: {
			type: String,
			required: true
		},
	},
	computed: {
		primaryColor() {
			return this.userStore.darkMode ? '1783f8' : '0752a3';
		},
		category() {
			return this.menuStore.modMenu.categories[this.categoryTempId];
		},
		iconsTaxonomy() {

			let iconsTaxonomy = [];
			let taxonomy = categoriesTaxonomy();
			taxonomy.forEach((taxonomyItem) => {
				if(this.userStore.currBusiness && taxonomyItem.type.includes(this.userStore.currBusiness.type)) {
					let existingTaxonomy = iconsTaxonomy.find((item) => {
						return item.taxonomy === taxonomyItem.taxonomy;
					});
					if(!existingTaxonomy) {
						iconsTaxonomy.push({
							taxonomy: taxonomyItem.taxonomy,
							icons: [taxonomyItem.file_name],
						});
					} else {
						existingTaxonomy.icons.push(taxonomyItem.file_name);
					}
				}
			});
			return iconsTaxonomy;
		}
	},
	methods: {
		saveClicked() {

			API.init().updateMenuCategoryTaxonomy(this.userStore.currBusinessId, this.category.menu_category_id, this.currentTaxonomyIcon, (response) => {
				if(response && response.result === "OK") {
					this.category.taxonomy = this.currentTaxonomyIcon;
					this.showNotification("generic-success");
					this.$emit("close");
				} else {
					this.showNotification("generic-fail");
				}
			});
		},
		selectTaxonomy(icon) {
			if(this.currentTaxonomyIcon === icon) {
				this.currentTaxonomyIcon = null;
			} else {
				this.currentTaxonomyIcon = icon;
			}
		}
	},
	mounted() {
		this.currentTaxonomyIcon = this.category.taxonomy;
	}
}
</script>

<style scoped lang="scss">
.taxonomy-chooser-container {
	width: 100%;

	.taxonomy-chooser {
		display: flex;
		flex-direction: column;
		width: 100%;

		.single-taxonomy {
			width: 100%;
			margin-bottom: 15px;

			.taxonomy-title {
				font-size: 16px;
				font-weight: bold;
				margin-bottom: 10px;
			}
			.taxonomy-icons {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.taxonomy-icon {
					width: 70px;
					height: 70px;
					border-radius: 16px;
					cursor: pointer;
					padding: 3px;
					position: relative;
					border: 3px solid transparent;
					transition: border-color 0.2s ease-in-out;

					.taxonomy-background {
						width: 100%;
						height: 100%;
						border-radius: 13px;
						overflow: hidden;
						position: relative;

						img {
							width: 100%;
							height: 100%;
						}

					}

					&.selected {
						border: 3px solid var(--color-primary);

					}

				}
			}
		}
	}
}
</style>